import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { CircleSpinner } from 'react-spinners-kit'
import { mdiDelete, mdiPencil, mdiPlusCircle } from '@mdi/js'
import { ParametroType } from '../Types/ParametroType'
import { setCurrentData, updateParametroFlagLaboratorio } from '../Reducers/ParametroReducer'
import getSinonimo from '../Scripts/getSinonimo'
import List, { ListColumn, ListOption, ListRow, ListSection } from '../../../../../components/List'
import { MenuItem, Select as SelectMUI, TextField } from '@material-ui/core'
import { activeItems } from '../../../../../constants/selects'
import changeLaboratorio from '../Scripts/changeLaboratorio'
import { useAppSelector } from '../../../../../store/hooks'

interface Props {
    lista: ParametroType[] | null
    loading: boolean
    setOpenEditar: (open: boolean) => void
    setOpenRemover: (open: boolean) => void
    setOpenCriarS: (open: boolean) => void
    canEdit: boolean
}
   
const TableListarParametroComponents: React.FC<Props> = ({ lista, loading, setOpenEditar, setOpenRemover, setOpenCriarS, canEdit }) => {

    const dispatch = useDispatch()
    
    const { userData } = useAppSelector(state => state.auth)
    const SHOW_LOADING = loading
    const SHOW_TABLE = !!lista && !loading

    const handleCreate = useCallback(async (item: ParametroType) => {
        await getSinonimo("RamoAtividadeParametroSinonimo", dispatch, item.id)
        dispatch(setCurrentData(item))
        setOpenCriarS(true)
    }, [dispatch, setOpenCriarS])

    const handleEdit = useCallback((item: ParametroType) => {
        dispatch(setCurrentData(item))
        setOpenEditar(true)
    }, [dispatch, setOpenEditar])

    const handleRemove = useCallback((item: ParametroType) => {
        dispatch(setCurrentData(item))
        setOpenRemover(true)
    }, [dispatch, setOpenRemover])

    const grid = "50px 1fr 80px  80px 80px 80px 80px 90px"

    return(
    
        <>
            <List name = "list">
                <ListSection type = "header">
                    <ListRow grid = {grid}>
                        {["Sigla", "Descrição", "Mínimo", "Máximo","Laboratorio" ,"Incerteza", "Situação", canEdit && "Opções"].map((item, index) => <ListColumn key = {index}>{item}</ListColumn>)}
                    </ListRow>
                </ListSection>
                <ListSection type = "main">
                    {SHOW_LOADING && (
                        <ListRow grid = '1fr'>
                            <ListColumn center><CircleSpinner size = {32} color = "grey" /></ListColumn>
                        </ListRow>
                    )}
                    {SHOW_TABLE && lista.map((item, index) => (
                        <ListRow key = {item.id} zebra = {index%2===0} grid = {grid}>

                            <ListColumn>{item.sigla}</ListColumn>
                            <ListColumn>{item.descricao}</ListColumn>
                            <ListColumn>{item.minimo}</ListColumn>
                            <ListColumn>{item.maximo}</ListColumn>
                            <ListColumn>
                                <SelectMUI type = "outline" value={item.flagLaboratorio? item.flagLaboratorio.toString(): '0'}  onChange={e => {
                                    const novoValor = Number(e.target.value)
                                    dispatch(updateParametroFlagLaboratorio({ id: item.id, valor: novoValor }))
                                    changeLaboratorio("Parametro",{ id: item.id, flagLaboratorio: novoValor, idUsuario: userData!.id } )
                                }} label = "Amostra laboratorio">

                                
                                <MenuItem value={'1'}>Sim</MenuItem>
                                <MenuItem value={'0'}>Não</MenuItem>

                                </SelectMUI>
                            </ListColumn>
                            
                            <ListColumn>{item.incerteza}%</ListColumn>
                            <ListColumn>{item.flagAtivo === 0 ? 'Desabilitado' : 'Habilitado'}</ListColumn>
                            {canEdit && <ListColumn>
                                <ListOption icon={mdiPlusCircle} onClick={() => handleCreate(item)} />
                                <ListOption icon = {mdiPencil} onClick = {() => handleEdit(item)} />    
                                <ListOption icon = {mdiDelete} status = "error" onClick = {() => handleRemove(item)} />
                            </ListColumn>}
                        </ListRow>
                    ))}
                </ListSection>
            </List>
        </>

    )

}

export default TableListarParametroComponents